"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.unidentifyUser = exports.unsetUserProperty = exports.setUserProperties = exports.setUserProperty = void 0;
const setupAmplitude_1 = __importDefault(require("./setupAmplitude"));
/**
 * Sets a user property for the current user.
 * https://developers.amplitude.com/docs/setting-user-properties#set
 */
const createUserPropertiesFunction = (amplitudeSetupFn = setupAmplitude_1.default) => {
    /**
     * @deprecated Please refer to this README {@link https://github.com/cultureamp/node-packages/tree/master/packages/amplitude#new-usage-more-detailed-guidance-will-be-updated-here}
     * Sets a user property for the current user.
     * https://developers.amplitude.com/docs/setting-user-properties#set
     */
    const setUserProperty = (propertyKey, propertyValue) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        return (_a = amplitudeSetupFn()) === null || _a === void 0 ? void 0 : _a.then(amplitude => {
            if (amplitude.success) {
                const identity = new amplitude.value.Identify();
                identity.set(propertyKey, propertyValue);
                amplitude.value.identify(identity);
            }
            return amplitude;
        });
    });
    /**
     * Sets multiple user properties for the current user.
     * https://developers.amplitude.com/docs/javascript#setting-multiple-user-properties
     */
    const setUserProperties = (userProperties) => __awaiter(void 0, void 0, void 0, function* () {
        const amplitude = yield amplitudeSetupFn();
        if (amplitude === null || amplitude === void 0 ? void 0 : amplitude.success) {
            amplitude.value.setUserProperties(userProperties);
        }
    });
    /**
     * @deprecated Please refer to this README {@link https://github.com/cultureamp/node-packages/tree/master/packages/amplitude#new-usage-more-detailed-guidance-will-be-updated-here}
     * Removes a set user property for the current user.
     * https://developers.amplitude.com/docs/setting-user-properties#unset
     */
    const unsetUserProperty = (propertyKey) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        return (_b = amplitudeSetupFn()) === null || _b === void 0 ? void 0 : _b.then(amplitude => {
            if (amplitude.success) {
                const identity = new amplitude.value.Identify();
                identity.unset(propertyKey);
                amplitude.value.identify(identity);
            }
            return amplitude;
        });
    });
    /*
     * Unidentify an user.
     * https://developers.amplitude.com/docs/javascript#log-out-and-anonymous-users
     */
    const unidentifyUser = () => __awaiter(void 0, void 0, void 0, function* () {
        const amplitude = yield amplitudeSetupFn();
        if (amplitude === null || amplitude === void 0 ? void 0 : amplitude.success) {
            amplitude.value.setUserId(null);
        }
    });
    return {
        setUserProperty,
        setUserProperties,
        unsetUserProperty,
        unidentifyUser,
    };
};
exports.default = createUserPropertiesFunction;
_a = createUserPropertiesFunction(), exports.setUserProperty = _a.setUserProperty, exports.setUserProperties = _a.setUserProperties, exports.unsetUserProperty = _a.unsetUserProperty, exports.unidentifyUser = _a.unidentifyUser;
//# sourceMappingURL=createUserPropertyFunctions.js.map